var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.recom_subscribers'),"text":_vm.$t('recom_subscribers.description'),"name":"recomSubscribers","url":_vm.$listRoutes.recomSubscribers,"table":_vm.recomSubscribers,"filters":_vm.recomSubscribersFilters,"fields":_vm.fields,"search":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }